export enum ConfigChannel {
  CREATE = 'config::create',
  EDIT = 'config::patch',
  DELETE = 'config::delete',
}
